<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <navigation
            :list="segments"
            :active-value="activeSegment"
            variety="segmented"
            @active:updated="tapNavigation"
          />
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          <keep-alive>
            <component :is="activeSegmentComponent" />
          </keep-alive>
        </div>
      </div>
    </div>
    <div class="chat_room_open_btn" @click="open_chat_room()"></div>
    <div id="new_chat_room"></div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Navigation from '~components/common/Navigation'
import EnterprisesList from './intern/EnterprisesList'
import RecordList from './intern/RecordList'
import { chat_room } from '~components/common/chat_room.js'
import '~style/components/chat_room.css'

export default {
  name: 'StudentsInternContent',
  components: {
    Navigation,
    EnterprisesList,
    RecordList
  },
  data () {
    return {
      segments: ['實習公司清單', '實習紀錄檢視'],
      segmentComponents: [EnterprisesList, RecordList],
      activeSegment: '實習公司清單',
      chat_room: null,
      student_id: null,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'tokenGetters'
    ]),
    ...mapGetters('pages/students', [
      'currentStudentGetter'
    ]),
    activeSegmentComponent () {
      return this.segmentComponents[this.segments.indexOf(this.activeSegment)]
    }
  },
  created () {
    const specificSegment = this.$route.query.tab
    if (specificSegment) {
      this.updateActiveSegment(specificSegment)
    }
  },
  async mounted () {
    this.togglePageLoader(true);
    await this.getStudentByToken();
    let el = $('#new_chat_room')[0];
    this.chat_room = new chat_room(el, {
      name: this.currentStudentGetter.student_name,
      token: this.tokenGetters,
    });
    this.student_id = this.currentStudentGetter.student_pk_id;
    this.togglePageLoader(false);
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/students', [
      'getStudentByToken',
    ]),
    tapNavigation (segment) {
      this.updateActiveSegment(segment)
      this.pushTabQuery(segment)
    },
    pushTabQuery (segment, sub) {
      if (sub) {
        this.$router.push({
          path: '/students/intern',
          query: {
            tab: segment,
            sub
          }
        })
      } else {
        this.$router.push({
          path: '/students/intern',
          query: {
            tab: segment
          }
        })
      }
    },
    updateActiveSegment (segment) {
      this.activeSegment = segment
    },
    open_chat_room () {
      if(this.chat_room && this.student_id) {
        this.chat_room.open(this.student_id);
      }
    },
  }
}
</script>
